export default {
  computed: {
    isIdDataIncorrect() {
      return !this.userData.national_id_number || !this.userData.id_document.type || 
        !this.userData.id_document.seriesNumber || !this.userData.id_document.issueDate ||
        !this.userData.id_document.expireDate || !this.userData.id_document.authority;
    }
  }
}